import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  user: {},
  users: [],
  loading: false,
  usersLoading: false,
  rolesLoading: false,
  shouldPermissionModalOpen: false,
  saveRoleLoading: false,
  updateInfoLoading: false,
  updatePicLoading: false,
  permissionLoading: false,
  updatePermissionLoading: false,
  workingHoursLoading: false,
  userStatusLoading: false,
  userCreateLoading: false,
  passwordLoading: false,
  error: "",
  roles: [],
  rolesPagination: {},
  usersPagination: {},
  permissions: [],
  groups: [],
});

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    // USER PROFILE
    case ACTIONS.USER_PROFILE.PENDING: {
      return state.set("loading", true);
    }
    case ACTIONS.USER_PROFILE.SUCCESS: {
      return state
        .set("loading", false)
        .set("error", "")
        .set("user", action.data);
    }
    case ACTIONS.USER_PROFILE.ERROR: {
      return state.set("loading", false).set("error", action.error);
    }

    // UPDATE USER PROFILE
    case ACTIONS.UPDATE_USER_PROFILE.PENDING: {
      return state.set("updateInfoLoading", true);
    }
    case ACTIONS.UPDATE_USER_PROFILE.SUCCESS: {
      return state
        .set("updateInfoLoading", false)
        .set("error", "")
        .set("user", action.data);
    }
    case ACTIONS.UPDATE_USER_PROFILE.ERROR: {
      return state.set("updateInfoLoading", false).set("error", action.error);
    }

    // UPDATE USER PROFILE PICTURE
    case ACTIONS.UPDATE_USER_PROFILE_PICTURE.PENDING: {
      return state.set("updatePicLoading", true);
    }
    case ACTIONS.UPDATE_USER_PROFILE_PICTURE.SUCCESS: {
      return state
        .set("updatePicLoading", false)
        .set("error", "")
        .set("user", action.data);
    }
    case ACTIONS.UPDATE_USER_PROFILE_PICTURE.ERROR: {
      return state.set("updatePicLoading", false).set("error", action.error);
    }

    // UPDATE WORKING HOURS
    case ACTIONS.UPDATE_WORKING_HOURS.PENDING: {
      return state.set("error", "").set("workingHoursLoading", true);
    }
    case ACTIONS.UPDATE_WORKING_HOURS.SUCCESS: {
      return state
        .set("error", "")
        .set("workingHoursLoading", false)
        .set("user", action.data);
    }
    case ACTIONS.UPDATE_WORKING_HOURS.ERROR: {
      return state.set("error", action.error).set("workingHoursLoading", false);
    }

    // SORT ROLES
    case ACTIONS.SORT_ROLES.PENDING: {
      return state.set("error", "").set("rolesLoading", true);
    }
    case ACTIONS.SORT_ROLES.SUCCESS: {
      return state
        .set("error", "")
        .set("roles", action.data.data)
        .set("rolesPagination", action.data.pagination)
        .set("rolesLoading", false);
    }
    case ACTIONS.SORT_ROLES.ERROR: {
      return state.set("error", action.error).set("rolesLoading", false);
    }
    // GET ROLES
    case ACTIONS.ROLES.PENDING: {
      return state.set("error", "").set("rolesLoading", true);
    }
    case ACTIONS.ROLES.SUCCESS: {
      return state
        .set("error", "")
        .set("roles", action.data.data)
        .set("rolesPagination", action.data.pagination)
        .set("rolesLoading", false);
    }
    case ACTIONS.ROLES.ERROR: {
      return state.set("error", action.error).set("rolesLoading", false);
    }
    // CREATE ROLE
    case ACTIONS.CREATE_ROLE.PENDING: {
      return state
        .set("error", "")
        .set("saveRoleLoading", true)
        .set("loading", true);
    }
    case ACTIONS.CREATE_ROLE.SUCCESS: {
      return state
        .set("error", "")
        .set("saveRoleLoading", false)
        .set("roles", action.data.data)
        .set("rolesPagination", action.data.pagination)
        .set("shouldPermissionModalOpen", true)
        .set("loading", false);
    }
    case ACTIONS.CREATE_ROLE.ERROR: {
      return state
        .set("error", action.error)
        .set("saveRoleLoading", false)
        .set("loading", false);
    }
    // UPDATE ROLE
    case ACTIONS.UPDATE_ROLE.PENDING: {
      return state.set("error", "").set("saveRoleLoading", true);
    }
    case ACTIONS.UPDATE_ROLE.SUCCESS: {
      return state
        .set("error", "")
        .set("saveRoleLoading", false)
        .set("roles", action.data.data)
        .set("rolesPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_ROLE.ERROR: {
      return state.set("error", action.error).set("saveRoleLoading", false);
    }
    // DELETE ROLE
    case ACTIONS.DELETE_ROLE.PENDING: {
      return state.set("error", "").set("saveRoleLoading", true);
    }
    case ACTIONS.DELETE_ROLE.SUCCESS: {
      return state
        .set("error", "")
        .set("saveRoleLoading", false)
        .set("roles", action.data.data)
        .set("rolesPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_ROLE.ERROR: {
      return state.set("error", action.error).set("saveRoleLoading", false);
    }

    // GET ROLE PERMISSIONS
    case ACTIONS.PERMISSIONS.PENDING: {
      return state.set("error", "").set("permissionLoading", true);
    }
    case ACTIONS.PERMISSIONS.SUCCESS: {
      return state
        .set("error", "")
        .set("permissions", action.data.permissions)
        .set("shouldPermissionModalOpen", true)
        .set("permissionLoading", false);
    }
    case ACTIONS.PERMISSIONS.ERROR: {
      return state
        .set("error", action.error)
        .set("shouldPermissionModalOpen", false)
        .set("permissionLoading", false);
    }
    // UPDATED ROLE PERMISSIONS
    case ACTIONS.UPDATE_PERMISSIONS.PENDING: {
      return state.set("updatePermissionLoading", true);
    }
    case ACTIONS.UPDATE_PERMISSIONS.SUCCESS: {
      return state
        .set("updatePermissionLoading", false)
        .set("error", "")
        .set("shouldPermissionModalOpen", false);
    }
    case ACTIONS.UPDATE_PERMISSIONS.ERROR: {
      return state
        .set("updatePermissionLoading", false)
        .set("error", action.error)
        .set("shouldPermissionModalOpen", false);
    }

    // SORT USERS
    case ACTIONS.SORT_USERS.PENDING: {
      return state.set("error", "");
    }
    case ACTIONS.SORT_USERS.SUCCESS: {
      return state
        .set("error", "")
        .set("users", action.data.data)
        .set("usersPagination", action.data.pagination);
    }
    case ACTIONS.SORT_USERS.ERROR: {
      return state.set("error", action.error);
    }

    case ACTIONS.USERS.PENDING: {
      return state.set("usersLoading", true).set("error", "");
    }
    case ACTIONS.USERS.SUCCESS: {
      return state
        .set("usersLoading", false)
        .set("error", "")
        .set("users", action.data.data)
        .set("usersPagination", action.data.pagination);
    }
    case ACTIONS.USERS.ERROR: {
      return state.set("error", action.error).set("usersLoading", false);
    }

    case ACTIONS.UPDATE_USER_STATUS.PENDING: {
      return state.set("userStatusLoading", true);
    }
    case ACTIONS.UPDATE_USER_STATUS.SUCCESS: {
      return state
        .set("userStatusLoading", false)
        .set("error", "")
        .set("users", action.data.data)
        .set("usersPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_USER_STATUS.ERROR: {
      return state.set("userStatusLoading", false).set("error", action.error);
    }
    // CREATE USER
    case ACTIONS.CREATE_USER.PENDING: {
      return state.set("userStatusLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_USER.SUCCESS: {
      return state
        .set("userStatusLoading", false)
        .set("error", "")
        .set("users", action.data.data)
        .set("usersPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_USER.ERROR: {
      return state.set("error", action.error).set("userStatusLoading", false);
    }
    // UPDATE USER
    case ACTIONS.UPDATE_USER.PENDING: {
      return state.set("userStatusLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_USER.SUCCESS: {
      return state
        .set("userStatusLoading", false)
        .set("error", "")
        .set("users", action.data.data)
        .set("usersPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_USER.ERROR: {
      return state.set("error", action.error).set("userStatusLoading", false);
    }
    // DELETE USER
    case ACTIONS.DELETE_USER.PENDING: {
      return state.set("userStatusLoading", true);
    }
    case ACTIONS.DELETE_USER.SUCCESS: {
      return state
        .set("userStatusLoading", false)
        .set("error", "")
        .set("users", action.data.data)
        .set("usersPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_USER.ERROR: {
      return state.set("userStatusLoading", false).set("error", action.error);
    }
    // RESET USER PASSWORD
    case ACTIONS.USER_RESET_PASSWORD.PENDING: {
      return state.set("passwordLoading", true);
    }
    case ACTIONS.USER_RESET_PASSWORD.SUCCESS: {
      return state.set("passwordLoading", false).set("error", "");
    }
    case ACTIONS.USER_RESET_PASSWORD.ERROR: {
      return state.set("passwordLoading", false).set("error", action.error);
    }

    default: {
      return state;
    }
  }
}
